import styled, { css } from 'react-emotion';
import { DateTimePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import UnStyledGroupIcon from '@material-ui/icons/Group';
import UnStyledHiddenIcon from '@material-ui/icons/VisibilityOff';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

import { createMuiTheme } from '@material-ui/core';

const formTheme = createMuiTheme({
  palette: {
    primary: {
      main: colors.purple,
    },
  },
  typography: {
    fontFamily: theme.font.family.workSans,
  },
});

const ModalContent = styled('div')`
  padding: 0;
  width: 526px;
  min-height: 450px;
  overflow: hidden;
`;

const Title = styled('div')`
  color: #31405c;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  font-family: ${theme.font.family.workSans};
`;

const SubTitle = styled('div')`
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 400;
  text-align: center;

  margin-top: 12px;
  font-family: ${theme.font.family.workSans};
`;

const StyledPickerLeft = styled(DateTimePicker)`
  width: calc(50% - 6px);
  margin-right: 6px;
  margin-top: 20px;
`;

const datePickerClass = styled('div')`
  z-index: 9999999999;
`;

const StyledPickerRight = styled(DateTimePicker)`
  width: calc(50% - 7px);
  margin-left: 7px;
  margin-top: 20px;
`;

const SwitchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px; /* 40px - 2px(borders) */
  margin-top: ${({ isTop }) => (isTop ? '24px' : '8px')};
`;

const SwitchLabel = styled('div')`
  color: #31405c;
  font-size: 12px;
  font-weight: 500;
  margin-left: 12px;
`;

const StyledTextField = styled(TextField)`
  margin-top: 24px;
  font-family: ${theme.font.family.workSans};
`;

const MaxGrade = styled(TextField)`
  margin-top: 24px;
  font-family: ${theme.font.family.workSans};
  width: 100px;
  margin-left: 12px;
`;

const GradeTypeSelect = styled(TextField)`
  margin-top: 24px;
  font-family: ${theme.font.family.workSans};
  width: 414px;
`;

const TH90Container = styled('div')`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 12px;

  border-bottom: 1px solid grey;
`;

const SwitchTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-left: 12px;
`;

const GroupIcon = styled(UnStyledGroupIcon)`
  font-size: 16px;
`;

const HiddenIcon = styled(UnStyledHiddenIcon)`
  font-size: 16px;
`;

const GroupSelector = styled('div')`
  margin-top: 8px;
  margin-left: 24px;
`;

const providerCapitalize = css`
  text-transform: capitalize;
`;

export {
  ModalContent,
  Title,
  SubTitle,
  StyledPickerLeft,
  StyledPickerRight,
  SwitchContainer,
  SwitchLabel,
  StyledTextField,
  datePickerClass,
  TH90Container,
  GroupIcon,
  HiddenIcon,
  SwitchTitleContainer,
  GroupSelector,
  providerCapitalize,
  formTheme,
  GradeTypeSelect,
  MaxGrade,
};
